// Minimum 8 characters, at least one uppercase letter, one lowercase letter, one number and one special character
export const passwordValidation = new RegExp(
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/
);

// regex for alphanumeric and can include #, _, - with no spaces
export const studyFieldRegex = new RegExp(/^[a-zA-Z0-9#_-]+$/);

// regex that matches exactly 10 digits
export const phoneNumberRegex = new RegExp(/^\d{10}$/);

//regex that Phone number can only contain digits, parentheses, plus, and hyphen
export const siteContactNumberRegex = new RegExp(/^[\d()+-]*$/);

//email regex
export const emailRegex = new RegExp(
  `^[a-zA-Z0-9.!#$%&'*+/=?^_\`{|}~-]{1,64}@` +
    `(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\\.){1,}` +
    `[a-zA-Z]{2,63}$`
);
